import { createFileRoute } from '@tanstack/react-router';

import { ActivityReportPage } from '@/features/nis2/components/ActivityReportPage';

export const Route = createFileRoute('/_authenticated/nis2/reports/activity')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ActivityReportPage />
      </div>
    </div>
  );
}
